import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from '../services/common.service';
@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  isToken: string = '';

  constructor(private route:Router,private service : CommonService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.isToken = localStorage.getItem('token')
      if (this.isToken){
        console.log('if block')
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));
        // console.log(userDetails, 'userDetails')
        const userRights = userDetails?.roleDetails?.rights;
        // console.log(userRights, 'userRights')
        let menus = this.service.menus;
        menus.forEach((element:any) => {
          element.isRight = userRights[element.previlageId];
        });
        menus = menus.filter((e:any) => e.isRight);
        if(menus?.length) {
          this.route.navigate([menus[0].link === "" ? menus[0].subMenu[0].link : menus[0].link])
        } else {
          this.route.navigate(['/core/accessdenied']);
        }
        return false;
      } else {
        console.log('else block')
        return true;
      }
  }

}
